// src/components/Report/shared/reportUtils.js
//
// Single source of truth for subject colors + score formatting.
// Used by: student report, teacher report, admin report, detailed view.

export const PALETTE = {
  Mathematics:        { solid: "#f97316", light: "#fff3e8", text: "#c2410c" },
  Maths:               { solid: "#f97316", light: "#fff3e8", text: "#c2410c" },
  Physics:            { solid: "#8b5cf6", light: "#f3f0ff", text: "#6d28d9" },
  Chemistry:          { solid: "#d97706", light: "#fffbeb", text: "#b45309" },
  Biology:            { solid: "#059669", light: "#ecfdf5", text: "#065f46" },
  English:            { solid: "#0891b2", light: "#ecfeff", text: "#155e75" },
  Science:            { solid: "#db2777", light: "#fdf2f8", text: "#9d174d" },
  "Computer science": { solid: "#2563eb", light: "#eff6ff", text: "#1e40af" },
  "Computer Science": { solid: "#2563eb", light: "#eff6ff", text: "#1e40af" },
  History:            { solid: "#0d9488", light: "#f0fdfa", text: "#115e59" },
  Geography:          { solid: "#65a30d", light: "#f7fee7", text: "#3f6212" },
  Hindi:              { solid: "#e11d48", light: "#fff1f2", text: "#9f1239" },
};

// Colors handed out (round-robin) to any subject not in PALETTE above,
// so unknown subjects still get a stable, distinct color instead of a fallback grey.
const FALLBACKS = [
  { solid: "#7c3aed", light: "#f5f3ff", text: "#4c1d95" },
  { solid: "#0369a1", light: "#f0f9ff", text: "#0c4a6e" },
  { solid: "#b45309", light: "#fffbeb", text: "#78350f" },
  { solid: "#15803d", light: "#f0fdf4", text: "#14532d" },
];

// NOTE: this cache is module-level, so it's shared across every component
// that imports `pal`. That's intentional — it's what keeps "Unknown Subject 1"
// the same color everywhere it appears on screen, across separate charts/pages.
const _dyn = {};
let _fi = 0;

/** Returns { solid, light, text } for a subject name, generating a stable fallback for unknown subjects. */
export function pal(sub) {
  if (PALETTE[sub]) return PALETTE[sub];
  if (!_dyn[sub]) {
    _dyn[sub] = FALLBACKS[_fi % FALLBACKS.length];
    _fi++;
  }
  return _dyn[sub];
}

export function hex2rgba(hex, a) {
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);
  return `rgba(${r},${g},${b},${a})`;
}

/**
 * Normalizes a raw score into a 0-100 percentage.
 * If `max` looks like a percentage scale already (>10) it's treated as already-scaled;
 * otherwise it's divided by max and converted to %.
 */
export function toPercent(score, max) {
  if (!max) return 0;
  return max > 10
    ? Math.min(100, Math.round(score))
    : Math.min(100, Math.round((score / max) * 100));
}

export function gradeBadge(pct) {
  if (pct >= 85) return { label: "A+", color: "#059669" };
  if (pct >= 70) return { label: "A", color: "#0891b2" };
  if (pct >= 55) return { label: "B", color: "#7c3aed" };
  if (pct >= 40) return { label: "C", color: "#d97706" };
  return { label: "D", color: "#ef4444" };
}